import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Command } from '../../../core/model/command';
import { ICommandHandler } from '../../../core/service/command/command-handler-resolver.service';
import { representativeCommand } from '../../command/representative.command';
import { Representative } from '../../model/representative';
import { RepresentativeService } from '../data/representative.service';

@Injectable()
export class SendRegistrationKeyRepresentativeCommandHandler implements ICommandHandler {
  constructor(private _representativeService: RepresentativeService) {}

  canExecute(command: Command): boolean {
    return command.id === representativeCommand.sendRegistrationKey && command.context;
  }

  execute(command: Command): Observable<void> {
    const representative = <Representative>command.context;
    return this._representativeService.sendRegistrationKey(
      representative.contactId,
      representative.contactEmail,
      representative.inviteCultureName
    );
  }
}
